// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { pickUpLocationAddressInfoDisplayStyles } from "@eisinc/Overrides/Widgets/CheckoutReviewAndSubmit/PickUpLocationAddressInfoDisplay";
import Directions from "@eisinc/XDL/Icons/Directions";
import Edit from "@eisinc/XDL/Icons/Edit";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

pickUpLocationAddressInfoDisplayStyles.headingGridItem = {
    css: css`
        margin-bottom: 12px;
    `,
};

pickUpLocationAddressInfoDisplayStyles.headingText = {
    variant: "h4",
    css: css`
        margin-bottom: 0;
    `,
};

pickUpLocationAddressInfoDisplayStyles.addressGridItem = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

pickUpLocationAddressInfoDisplayStyles.locationNameText = {
    size: fontConfig.singleLineSmall.size,
    lineHeight: fontConfig.singleLineSmall.lineHeight,
    weight: fontConfig.weight.medium,
    css: css`
        margin-bottom: 4px;
    `,
};

pickUpLocationAddressInfoDisplayStyles.changeLink = {
    icon: {
        iconProps: {
            src: Edit,
            color: "text.link",
            size: 12,
            css: css`
                margin-right: 6px;
                opacity: 0.5;
            `,
        },
        position: "left",
    },
    typographyProps: {
        size: fontConfig.singleLinexSmall.size,
        lineHeight: fontConfig.singleLinexSmall.lineHeight,
    },
    css: css`
        margin-top: 12px;
        align-self: baseline;
    `,
};

pickUpLocationAddressInfoDisplayStyles.directionsLink = {
    icon: {
        iconProps: {
            src: Directions,
            color: "text.link",
            size: 12,
            css: css`
                margin-right: 6px;
                opacity: 0.5;
            `,
        },
        position: "left",
    },
    typographyProps: {
        size: fontConfig.singleLinexSmall.size,
        lineHeight: fontConfig.singleLinexSmall.lineHeight,
    },
    css: css`
        margin-top: 12px;
        align-self: baseline;
    `,
};

pickUpLocationAddressInfoDisplayStyles.changeFulfilmentLink = {
    typographyProps: {
        size: fontConfig.singleLinexSmall.size,
        lineHeight: fontConfig.singleLinexSmall.lineHeight,
    },
    css: css`
        margin-top: 12px;
        align-self: baseline;
    `,
};

pickUpLocationAddressInfoDisplayStyles.pickUpDateContainer = {
    css: css`
        margin-top: 12px;
    `,
};

pickUpLocationAddressInfoDisplayStyles.messagesContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
        margin-top: 12px;
    `,
};

pickUpLocationAddressInfoDisplayStyles.message = {
    size: fontConfig.singleLineSmall.size,
    lineHeight: fontConfig.singleLineSmall.lineHeight,
    weight: fontConfig.weight.regular,
    color: "text.main",
    css: css`
        margin-bottom: 0;
        & > ${TypographyStyle} {
            color: inherit;
            font-size: inherit;
            font-weight: inherit;
            line-height: inherit;
            margin-bottom: 0;
        }
    `,
};
